/**
 * Works per page.
 *
 * Matches the default in `ondo.search_owned_works` and the one the API applies
 * when a caller names none, so the three cannot disagree about what a page is.
 */
export const PAGE_SIZE = 24;

/**
 * How long the search box waits after the last keystroke.
 *
 * `search_artists`, the only other searchable endpoint here, is undebounced —
 * one request per keystroke, gated by a two-character minimum. That is
 * defensible for a typeahead returning at most twenty names; it is not for a
 * paged endpoint that also counts the match set, and where the first request is
 * made with no query at all.
 */
export const DEBOUNCE_MS = 250;

export const WORK_PICKER_COPY = {
  title: "Choose works",
  open: "Choose works…",
  done: "Done",

  searchLabel: "Search your works",
  searchHint: "By title or by artist. Leave it empty to see everything you can publish.",

  firstLoad: "Loading your works…",
  /** This account owns no works at all — a search cannot fix that. */
  nothing:
    "You do not own any works yet. Register one, or build the room over a whole collection.",
  /** It owns works; none match what was typed. A different sentence on purpose. */
  noMatches: "No works match that. Try a title or an artist's name.",
  failed: "Could not load your works. Try again.",

  previous: `Previous ${String(PAGE_SIZE)}`,
  next: `Next ${String(PAGE_SIZE)}`,
  pagesLabel: "Pages",

  chosenNone: "Nothing chosen yet",
  remove: "Remove",
  /** Said once, near the Done button, because Escape and the backdrop do it too. */
  closeNote: "Your choices are kept as you make them. Close this when you are done.",

  atCapacity:
    "That is as many works as one room can hold. Remove one to choose another.",
} as const;
